import { shortId } from "@intelligems/ig-utils";
import { getPluginCdnUrl } from "@src/utils/getPluginCdnUrl";

export const intelligemsFullThemeSnippet = `<script>
    window.Shopify = window.Shopify || {theme: {id: {{ theme.id }}, role: '{{ theme.role }}' } };
    window._template = {
        directory: "{{ template.directory }}",
        name: "{{ template.name }}",
        suffix: "{{ template.suffix }}"
    };
    window.__productIdFromTemplate = {{ product.id | json }};
    window.__plpCollectionIdFromTemplate = {{ collection.id | json }};
    window.igProductData = (function() {
      const data = {};
      {%- if template.name == 'collection' -%}
        {%- for product in collection.products -%}
          data["{{ product.id }}"] = {
            productId: {{ product.id | json }},
            handle: {{ product.handle | json }},
            tags: {{ product.tags | json }},
            collectionIds: [{% for col in product.collections %}{{ col.id }}{% unless forloop.last %},{% endunless %}{% endfor %}],
            inventory: {% assign total = 0 %}{% for v in product.variants %}{% assign total = total | plus: v.inventory_quantity %}{% endfor %}{{ total }},
            lowestVariantPrice: {{ product.price_min }}
          };
        {%- endfor -%}
      {%- elsif template.name == 'product' -%}
        data["{{ product.id }}"] = {
          productId: {{ product.id | json }},
          handle: {{ product.handle | json }},
          tags: {{ product.tags | json }},
          collectionIds: [{% for col in product.collections %}{{ col.id }}{% unless forloop.last %},{% endunless %}{% endfor %}],
          inventory: {% assign total = 0 %}{% for v in product.variants %}{% assign total = total | plus: v.inventory_quantity %}{% endfor %}{{ total }},
          lowestVariantPrice: {{ product.price_min }}
        };
      {%- endif -%}
      return data;
    })();
  </script>`;

/** The CDN URL of the org's plugin bundle — the `src` used by `IgScript`. */
export const getIgBundleUrl = (orgId: string) =>
  `${getPluginCdnUrl()}/esm/${shortId(orgId)}/bundle.js`;

export const IgScript = (orgId: string, renderBlocking?: boolean) =>
  `<script type="module"${renderBlocking ? ' blocking="render"' : ""} fetchpriority="high" src="${getIgBundleUrl(orgId)}" data-em-disable async></script>`;

export const FullIgScript = (orgId: string, renderBlocking?: boolean) =>
  `${intelligemsFullThemeSnippet}
  ${IgScript(orgId, renderBlocking)}`;
